module.exports = __webpack_public_path__ + "static/media/course.95b93a80.png";